import lodash from 'lodash';
import React from 'react';
import withDraggable from '~app/core/withDraggable';

const icons = {
  '+': 'plus',
  '-': 'minus',
  0: 'neutral',
};

const connectorPolarity = {
  '+': 'positive',
  '-': 'negative',
  0: 'neutral',
};

// connector component which is draggable
// Note aria-label overrides aria-current and content of the div
function SignalHandle({
  polarity,
  selected,
  A3MGconnectionTo,
  A3MGconnectionFrom,
  hasError,
  pendingRecheck,
}) {
  return (
    <div
      className={`canvas__signal_handle handle ${selected ? 'selected' : ''}`}
      tabIndex={0}
      role="button"
      aria-dropeffect={selected ? 'move' : 'none'}
      aria-grabbed={selected}
      aria-current={selected}
      /*aria-label={`draggable ${connectorPolarity[polarity]} connector ${
        selected ? 'current' : ''
      }`}*/
      aria-label={`draggable ${
        connectorPolarity[polarity]
      } connector from ${A3MGconnectionFrom} to ${A3MGconnectionTo} ${
        selected ? 'current' : ''
      }`}
    >
      <div
        className={`canvas__signal_handle_icon canvas__signal_handle_icon-${icons[polarity]}`}
      ></div>
      {hasError && (
        <div
          className={`canvas__node__errormark ${
            pendingRecheck ? 'canvas__node__errormark-pending' : ''
          }`}
        ></div>
      )}
    </div>
  );
}

export default React.memo(
  withDraggable(SignalHandle, {
    draggableProps: { handle: '.handle', defaultClassName: 'canvas-draggable' },
  }),
  lodash.isEqual,
);
